import { type ActionReference } from "@/shared/domain/actions";

import { type TargetActionReference } from "./TriggerRecord";

/**
 * The action a trigger target runs, naming the org that owns it: the stored
 * owner, or the trigger's own org when the target stores none. The backend
 * resolves an action the same way, and treats an empty owner as none.
 */
export function targetActionReference(
  action: TargetActionReference,
  triggerOrgId: string,
): ActionReference & { owner: string } {
  return {
    name: action.name,
    owner: action.owner || triggerOrgId,
    digest: action.digest ?? undefined,
  };
}
